import React, { useState } from 'react'
import cn from 'classnames'
import styles from './UseCases.module.sass'
import Item from './Item'

const items = [
  {
    items: [
      {
        title: "OCR and data extraction",
        guild: "AI & Data",
        image: "img/logo-mini-zalando@1.5x.png",
        image2x: "img/logo-mini-zalando@2x.png",
        position: "Data Engineer at Zalando",
        ask: `I’d like to be in touch with someone who has experience with OCR
              and structured data extraction from scanned documents
              i.e.: bookkeeping documents and financial statements. Thanks!`
      },
      {
        title: "Flutter cross-platform app with AI",
        guild: "Mobile",
        image: "img/logo-mini-balance@1.5x.png",
        image2x: "img/logo-mini-balance@2x.png",
        position: "Software Engineer at Balance",
        ask: `I’m working on a PoC app built with Flutter. The app will embed an
              AI-based recommandation system. I’d like to have some high-level guidance
              on how to architecture the mobile app interface with the back-end.`
      },
      {
        title: "Next.js and TypeScript migration",
        guild: "Front-end",
        image: "img/logo-mini-see@1.5x.png",
        image2x: "img/logo-mini-see@2x.png",
        position: "Front-end Engineer at See Tickets",
        ask: `Migrating our React JavaScript front-end to Next.js and TypeScript.
              Looking for guidance in this migration of 250,000+ content pages and
              dynamic member area. Non e-commerce. How would you approach this step by step,
              to minimize down-time and ensure high quality delivery?`
      },
      {
        title: "From monolith to micro-services",
        guild: "Back-end",
        image: "img/logo-mini-orange@1.5x.png",
        image2x: "img/logo-mini-orange@2x.png",
        position: "Senior Back-end Engineer at Orange",
        ask: `The product I’m working on is mostly composed of a single repo monolith app.
              I’m already developing services outside of it, but feeling like we need to
              migrate this monolith one day or another. I’m quite afraid to launch this project,
              looking for guidance on how to get up to speed in this migration to micro-services.`
      },
      {
        title: "Databases migration, cloud and managed solution",
        guild: "DevOps",
        image: "img/logo-mini-airliq@1.5x.png",
        image2x: "img/logo-mini-airliq@2x.png",
        position: "Back-end Engineer at Air Liquide",
        ask: `I have a database migration to perform and I am wondering if the AWS Aurora
              cloud solution is the best solution for me, I am looking for strategic advice
              to help me plan my migration.`
      },
      {
        title: "Metamask and MathWallet React integration",
        guild: "Blockchain",
        image: "img/logo-mini-circularize@1.5x.png",
        image2x: "img/logo-mini-circularize@2x.png",
        position: "Front-end developer at Circularise",
        ask: `I run into compatibility issues with Metamask and MathWallet integration.
              I’m working on a react app, and I can’t find a way to have both work in
              a seamless way. Looking for help to get unstuck with this.`
      },
    ],
  },
]

export const UseCases = () => {
  const options = []
  items.map((x) => options.push(x.title))

  const [category, setCategory] = useState(options[0])

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>
            What they need help with
          </div>
          <h2 className={cn("h2", styles.title)}>Use cases</h2>
          <div className={styles.info}>
            Our customers have technical challenges,<br />
            and they need more guidance on your expertise. 
          </div>
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  )
}

export default UseCases
